import React from 'react';
import "../styles/BaseLayout.scss"
import {Outlet, useNavigate} from "react-router";


export default function AuthLayout() {
    const navigate = useNavigate();

    return (
        <>
            <div className={"flex-row space-between litle-margin"}>
                <div className={"title"}>Pro des notes</div>
                <div className={"auth"}>
                    <h2 className="pointer" onClick={() => navigate('/auth/login')}>Connexion</h2>
                    <h2 className="pointer" onClick={() => navigate('/auth/register')}>Inscription</h2>
                </div>
            </div>
            <Outlet/>
        </>
    );
}


